module.exports = __webpack_public_path__ + "img/mcb-yr1.8b64c07e.gif";